export const GET_ROLES = "GET_ROLES";
export const CREATE_ROLE = "CREATE_ROLE";
export const EDIT_ROLE = "EDIT_ROLE";
export const DELETE_ROLE = "DELETE_ROLE";
export const UPDATE_ROLE_STATUS = "UPDATE_ROLE_STATUS";
export const GET_ELIGIBLE_ROLES = "GET_ELIGIBLE_ROLES";
